<ng-content ng-select="rt-typeahead-source"></ng-content>
<ng-template [origin]="this" [width]="width" [positions]="positions" rt-connected-overlay>
  <ng-container *ngIf="suggestionEnabled">
    <ng-container
      *ngTemplateOutlet="
        suggestionsDropdownTpl ? suggestionsDropdownTpl : defaultSuggestionsTpl;
        context: suggestionsContext
      "
    ></ng-container>
  </ng-container>
</ng-template>

<ng-template
  #defaultSuggestionsTpl
  let-typeaheadstate="typeaheadstate"
  [ngTemplateType]="suggestionsContext"
>
  <rt-typeahead-suggestions
    [stateName]="typeaheadstate.name"
    [stateValue]="typeaheadstate.value"
    [suggestions]="typeaheadstate.suggestions"
    [highlighted]="typeaheadstate.highlighted!"
    (mousedown)="$event.stopImmediatePropagation(); $event.preventDefault()"
    (suggestionSelect)="select($event)"
  >
  </rt-typeahead-suggestions>
</ng-template>
